<template>
    <svg id="logo" width="72" height="30" viewBox="0 0 72 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.4952 0C4.7074 0 0 4.7074 0 10.4952V30H6V25.9678C7.36977 26.6238 8.89389 26.9904 10.4952 26.9904C16.283 26.9904 20.9904 22.283 20.9904 16.4952V10.4952C20.9904 4.7074 16.283 0 10.4952 0ZM15.0096 16.4952C15.0096 18.9839 12.9839 20.9904 10.5145 20.9904C8.04502 20.9904 6.01929 18.9646 6.01929 16.4952V10.4952C6.01929 8.00643 8.04502 6 10.5145 6C12.9839 6 15.0096 8.02572 15.0096 10.4952V16.4952Z"
            :fill="fill_1"
        />
        <path
            d="M39.0099 16.493C39.0099 18.9818 36.9842 20.9882 34.5147 20.9882C32.0453 20.9882 30.0195 18.9625 30.0195 16.493V1.56055H24.0195V16.493C24.0195 22.2808 28.7269 26.9882 34.5147 26.9882C40.3025 26.9882 45.0099 22.2808 45.0099 16.493V1.56055H39.0099V16.493Z"
            :fill="fill_1"
        />
        <path
            d="M68.9326 16.4937V10.4937C68.9326 4.80234 64.3024 0.191406 58.6304 0.191406C52.9583 0.191406 48.3281 4.82163 48.3281 10.4937V16.4937C48.3281 22.185 52.9583 26.7959 58.6304 26.7959C59.0162 26.7959 59.3828 26.7766 59.7686 26.738L62.9519 29.9213L71.9423 20.9117L68.8555 17.8248C68.9133 17.3811 68.9519 16.9567 68.9519 16.4937H68.9326ZM53.923 16.4937V10.4937C53.923 7.90845 56.0259 5.80555 58.6111 5.80555C61.1963 5.80555 63.2992 7.90845 63.2992 10.4937V16.4937C63.2992 19.0789 61.1963 21.1818 58.6111 21.1818C56.0259 21.1818 53.923 19.0789 53.923 16.4937Z"
            :fill="fill_2"
        />
    </svg>
</template>

<script setup>
    const props = defineProps({
        fill_1: {
            type: String,
            default: "#F1F1F1"
        },
        fill_2: {
            type: String,
            default: "#E86600"
        }
    });
</script>
